import React from 'react';

import { ErrorHandler } from '@playbookux/playbook-web-core';

import {
  bool, func, shape, string,
} from 'prop-types';
import {
  Button,
  ButtonArea,
  Container,
  Dialog,
  Content,
  Text,
} from './styles';

const FINISH_BUTTON_TEXTS = {
  SUBMIT_MESSAGE: 'Do you want to submit this study?',
  WARNING_MESSAGE: "You can't make changes after submitting",
  CANCEL_MESSAGE: "No, don't submit",
  CONFIRM_MESSAGE: 'Yes, submit',
};

const SORTED_CARDS_TEXT = {
  SUBMIT_MESSAGE: "You've sorted every card",
  WARNING_MESSAGE: 'Do you want to submit the study? You won’t be able to make any changes after submitting your study.',
  CANCEL_MESSAGE: "I'm not done yet",
  CONFIRM_MESSAGE: 'Submit now',
};

const SubmitModal = (props) => {
  const {
    error,
    loading,
    onClose,
    onSubmit,
    show,
    isSortedCards,
  } = props;

  const modalTexts = isSortedCards ? SORTED_CARDS_TEXT : FINISH_BUTTON_TEXTS;

  const {
    SUBMIT_MESSAGE,
    WARNING_MESSAGE,
    CANCEL_MESSAGE,
    CONFIRM_MESSAGE,
  } = modalTexts;

  return (
    <Container
      active={show}
      onClickOutside={onClose}
      page
    >
      <Dialog isSortedCards={isSortedCards}>
        <Content>
          <Text>{SUBMIT_MESSAGE}</Text>
          <Text>{WARNING_MESSAGE}</Text>
        </Content>

        {error && (
          <ErrorHandler
            error={error}
            defaultMessage="Error while submitting."
          />
        )}

        <ButtonArea>
          <Button.Inverted onClick={onClose} data-modal-close>
            {CANCEL_MESSAGE}
          </Button.Inverted>

          <Button
            onClick={onSubmit}
            disabled={loading}
            loading={loading}
            data-modal-submit
          >
            {CONFIRM_MESSAGE}
          </Button>
        </ButtonArea>
      </Dialog>
    </Container>
  );
};

SubmitModal.propTypes = {
  error: shape({
    message: string,
  }),
  loading: bool,
  onClose: func.isRequired,
  onSubmit: func.isRequired,
  show: bool,
  isSortedCards: bool,
};

SubmitModal.defaultProps = {
  error: null,
  loading: false,
  show: false,
  isSortedCards: false,
};

export default SubmitModal;
